import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
  FwAlertComponent,
  FwProgressSpinnerComponent,
  FwSelectMenuComponent,
  FwWrappedInputComponent,
} from '@flywheel-io/vision';

import { DirectivesModule } from '../common/directives.module';
import { ContainerModule } from '../containers/container.module';
import { FileModule } from '../files/file.module';
import { MaterialModule } from '../material.module';
import { PipesModule } from '../shared/pipes.module';
import { SharedModule } from '../shared/shared.module';
import { AcquisitionInfoDialog } from './acquisition-info-dialog/acquisition-info-dialog.component';
import { AcquisitionNotesDialog } from './acquisition-notes-dialog/acquisition-notes-dialog.component';
import { AddToCollectionDialog } from './add-to-collection-dialog/add-to-collection-dialog.component';
import { CreateSubjectDialog } from './create-subject-dialog/create-subject-dialog.component';
import { MoveAcquisitionsToSessionDialog } from './move-acquisitions-to-session/move-acquisitions-to-session-dialog.component';
import { MoveSessionsToSubjectDialog } from './move-sessions-to-subject/move-sessions-to-subject-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    ContainerModule,
    DirectivesModule,
    DragDropModule,
    FileModule,
    FormsModule,
    FwAlertComponent,
    FwProgressSpinnerComponent,
    ReactiveFormsModule,
    MaterialModule,
    PipesModule,
    SharedModule,
    RouterModule,
    FwWrappedInputComponent,
    FwSelectMenuComponent,
  ],
  declarations: [
    AcquisitionInfoDialog,
    AcquisitionNotesDialog,
    AddToCollectionDialog,
    CreateSubjectDialog,
    MoveAcquisitionsToSessionDialog,
    MoveSessionsToSubjectDialog,
  ],
})
export class SessionModule {}
